module.exports = __webpack_public_path__ + "static/DeadlineAssistant-eb306e66374164005c697d1640166e7c.jpg";